import { getOrigin } from "./browser.utils"

export function getEventDetailsURL(slug: string): string {
  return `${getOrigin()}/events/${slug}`
}
